module.exports = __webpack_public_path__ + "static/sf_12.6af26666.png";